'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Badge = require('react-bootstrap/lib/Badge');

var _Badge2 = _interopRequireDefault(_Badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Badge2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/Badge.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/Badge.js
 ** module chunks = 0
 **/